import React from 'react'
import Image from '../../../images/sellerpolicies/19.png'

const Seller_performance = () => {
  return (
    <div className='sp_details_wrapper'>
      <div className='sp_details_container'>
        <div className='sp_details_image'>
            <img src={Image} alt='policy'/>
        </div>
        <div className='sp_details_details'>
            <h2>Seller Performance.</h2>
            <p>KAAY measures Seller performance on an ongoing basis and will share a monthly performance report with the respective Seller</p>
            <p>KAAY will rank the Seller based on performance on the base of following criteria as follow: </p>
            <ul>
                <li>a.	<b>Seller Order Cancellation Rate</b><br></br>% orders canceled by the seller, Customer, or KAAY because of a delay from the Seller.</li>
                <li>b.	<b>Quality Issue Rate</b><br></br>The new Quality Issue Rate is a seller's performance based on his returns (because of seller’s fault such as wrong item, wrong size, damaged items, missing items, & wrong color), product ratings & buyer complaints for all delivered orders.</li>
                <li>c.	<b>% Processing Time</b><br></br>A number of orders shipped within two days against all orders received.</li>
                <li>d.	<b>Response Rate</b> <br></br>KAAY may, at any time, delist, downgrade or upgrade the Seller shop depending on commercial and operational performance without any prior intimation or notice to the Seller.</li>
            </ul>
        </div>
      </div>
    </div>
  )
}

export default Seller_performance
